const wrapText = (ctx, text, maxWidth) => {
  const words = text.split(" ");
  const lines = [];
  let line = "";
  words.forEach((w) => {
    const test = line ? `${line} ${w}` : w;
    if (ctx.measureText(test).width > maxWidth && line) {
      lines.push(line);
      line = w;
    } else {
      line = test;
    }
  });
  if (line) lines.push(line);
  return lines;
};

const drawDandelionMark = (ctx, cx, cy, r) => {
  const glow = ctx.createRadialGradient(cx, cy, 8, cx, cy, r * 1.5);
  glow.addColorStop(0, "rgba(252, 211, 77, 0.45)");
  glow.addColorStop(1, "rgba(252, 211, 77, 0)");
  ctx.fillStyle = glow;
  ctx.beginPath();
  ctx.arc(cx, cy, r * 1.5, 0, Math.PI * 2);
  ctx.fill();
  ctx.strokeStyle = "#FBBF24";
  ctx.lineWidth = 2.5;
  for (let i = 0; i < 22; i++) {
    const a = (i / 22) * Math.PI * 2;
    ctx.beginPath();
    ctx.moveTo(cx, cy);
    ctx.lineTo(cx + Math.cos(a) * r, cy + Math.sin(a) * r);
    ctx.stroke();
    ctx.fillStyle = "#FCD34D";
    ctx.beginPath();
    ctx.arc(cx + Math.cos(a) * r, cy + Math.sin(a) * r, 4.5, 0, Math.PI * 2);
    ctx.fill();
  }
  ctx.fillStyle = "#D97706";
  ctx.beginPath();
  ctx.arc(cx, cy, 12, 0, Math.PI * 2);
  ctx.fill();
};

export const generateSuitInsightImage = ({ suit, insight }) =>
  new Promise((resolve) => {
    const W = 1080;
    const H = 1350;
    const c = document.createElement("canvas");
    c.width = W;
    c.height = H;
    const ctx = c.getContext("2d");

    ctx.fillStyle = "#0F766E";
    ctx.fillRect(0, 0, W, H);
    ctx.fillStyle = "rgba(255,255,255,0.04)";
    ctx.beginPath();
    ctx.arc(W, 0, 500, 0, Math.PI * 2);
    ctx.fill();
    ctx.strokeStyle = "rgba(251, 191, 36, 0.55)";
    ctx.lineWidth = 3;
    ctx.strokeRect(50, 50, W - 100, H - 100);

    ctx.textAlign = "center";
    ctx.fillStyle = "#FCD34D";
    ctx.font = "bold 26px Arial, sans-serif";
    ctx.fillText("W H A T   T H I S   S E A S O N   I S   T E A C H I N G   M E", W / 2, 145);

    drawDandelionMark(ctx, W / 2, 270, 62);

    ctx.fillStyle = "rgba(255,255,255,0.7)";
    ctx.font = "bold 24px Arial, sans-serif";
    ctx.fillText("M Y   G U I D I N G   S U I T", W / 2, 410);
    ctx.fillStyle = "#FFFFFF";
    ctx.font = "bold 86px Georgia, serif";
    ctx.fillText(suit, W / 2, 505);

    ctx.strokeStyle = "rgba(252, 211, 77, 0.5)";
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(W / 2 - 100, 555);
    ctx.lineTo(W / 2 + 100, 555);
    ctx.stroke();

    ctx.fillStyle = "rgba(255,255,255,0.92)";
    ctx.font = "italic 31px Georgia, serif";
    let lines = wrapText(ctx, insight, W - 220);
    const maxLines = 13;
    if (lines.length > maxLines) {
      lines = lines.slice(0, maxLines);
      lines[maxLines - 1] = lines[maxLines - 1].replace(/[,.\s]+$/, "") + "…";
    }
    lines.forEach((l, i) => ctx.fillText(l, W / 2, 630 + i * 46));

    ctx.fillStyle = "#FCD34D";
    ctx.font = "bold 24px Arial, sans-serif";
    ctx.fillText("B E   T H E   L I G H T", W / 2, 1240);
    ctx.fillStyle = "rgba(255,255,255,0.7)";
    ctx.font = "italic 24px Georgia, serif";
    ctx.fillText("Dandelion Farm · House of Bloom", W / 2, 1285);

    c.toBlob(resolve, "image/png");
  });
